import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UserStore} from 'src/app/modules/authentication/state/user.store';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {newGuid} from '../question-helper';
import {QuestionFlowSessionQuery} from '../state/question-flow-session.query';
import { Alert } from '../../utilities';

declare var $: any;

@Component({
    selector: 'app-question-verify-email',
    templateUrl: './question-verify-email.component.html',
    styleUrls: ['./question-verify-email.component.scss'],
    standalone: false
})
export class QuestionVerifyEmailComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = false;
  @Input() isIdInput = false;
  @Input() clearValues = false;
  @Output() questionAnswer = new EventEmitter();

  uniqueControlName = `textbox-${newGuid()}`;
  uniqueId = `textbox-${newGuid()}`;
  value = '';
  verify = '';
  valid = false;
  errorMessage = '';
  user: any;
  constructor(
    public globalQuestionService: GlobalQuestionService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
    private userStore: UserStore
  ) {
    this.user = this.userStore.getValue();
    
  }

  ngOnInit(): void {
    if (this.question?.answer) {
      this.value = this.question.answer;
    }
    if (this.user.broker_id > 0){
      $('#'+this.question.cent_aq_question_id).html("Please confirm <strong>your client's</strong> email address and contact number.")
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.clearValues = changes?.clearValues?.currentValue;
    if (this.clearValues) {
      this.clearEmail();
    }
    if (changes?.showLabel?.currentValue !== changes?.showLabel?.previousValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
    }
  }

  validateEmail(email): void {
    this.valid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(email?.trim());
  }

  upperCase(): void {
    if (this.question?.cent_aq_question_id === 57) {
      this.value = this.value.toUpperCase();
    }
  }

  saveValue(): void {
    if (this.value) {
      this.question.answer = this.value;
    } else {
      this.clearEmail();
    }
  }

  onEmailChange(): void {
    this.saveValue();
    if (this.verify) {
      this.emailExists();
    }
  }

  emailExists(): void {
    this.errorMessage = '';
    if (!this.value) { return; }
    this.validateEmail(this.value);
    if (!this.valid) {
      this.errorMessage = 'Please enter a valid email address.';
      this.question.answer = null;
       this.questionAnswer.emit(this.question);
      return;
    }
    if (!this.verify) { return; }
    if (this.verify?.trim().toLowerCase() !== this.value?.trim().toLowerCase()) {
      this.errorMessage = 'Email addresses do not match.';
       this.question.answer = null;
       this.questionAnswer.emit(this.question);
      return;
    }
    if (this.value && (this.verify === this.value)) {
      //this.globalQuestionService.spinner(true);
      this.globalQuestionService.spinnerTransparent(true);
      this.question.answer = this.value;
      this.questionAnswer.emit(this.question);
      const session_details = this.questionFlowSessionQuery.getValue();
      this.globalQuestionService.saveAnswerOnly(this.question).subscribe(() => {
        const parameters = new Map<string, string>();
        parameters.set('email', this.value);
        parameters.set('session_id', session_details.session_id);
        parameters.set('category_id', `${session_details.category_id}`);
        parameters.set('group_id', `${session_details.group_id}`);
        this.globalQuestionService.runCommandNew('checkEmailExists', parameters)
          .subscribe((response: any[]) => {
            if (response?.length) {
              if (response[0].warning) {
                Alert(response[0].warning, 5000);
                this.clearEmail();
                this.globalQuestionService.spinnerTransparent(false);
                return
              }
              if (response[0].verified === 1) {
                //this.globalQuestionService.spinner(false);
                this.globalQuestionService.spinnerTransparent(false);
                const broker_id = this.userStore.getValue()?.broker_id;
                if (!broker_id || broker_id === 0) { // If Broker is logged in, don't show modal
                  if (!response[0].warning) {
                    $('#verify-login-alert-modal').modal('show');
                  }
                  else {
                    Alert(response[0].warning, 5000);
                    this.clearEmail();
                    
                  }
                }
                
              } else {
                const parameters = new Map<string, string>();
                parameters.set('new_session_id', session_details.session_id);
                parameters.set('category_id', session_details.category_id?.toString());
                parameters.set('product_group_id', session_details.group_id?.toString());
                parameters.set('product_id', session_details.product_id?.toString());
                parameters.set('user_id', response[0].person_id?.toString());

                this.globalQuestionService.runCommandNew(`updateQuote`, parameters)
                  .subscribe(() => {
                    //this.globalQuestionService.spinner(false);
                    this.globalQuestionService.spinnerTransparent(false);
                  }, error => {
                    //this.globalQuestionService.spinner(false);
                    this.globalQuestionService.spinnerTransparent(false);
                  });
              }
            } else {
              //this.globalQuestionService.spinner(false);
              this.globalQuestionService.spinnerTransparent(false);
            }
          }, err => {
            console.log(err);
            //this.globalQuestionService.spinner(false);
            this.globalQuestionService.spinnerTransparent(false);
          });
      });
    } else {

    }
  }

  clearEmail(): void {
    this.value = '';
    this.verify = '';
    this.question.answer = '';
    this.questionAnswer.emit(this.question);
    this.globalQuestionService.saveAnswerOnly(this.question).subscribe();
  }

}
